/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUsername(str) {
  const valid_map = ['admin', 'editor']
  return valid_map.indexOf(str.trim()) >= 0
}

/**
 * @param {string} url
 * @returns {Boolean}
 */
export function validURL(url) {
  const reg = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
  return reg.test(url)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validLowerCase(str) {
  const reg = /^[a-z]+$/
  return reg.test(str)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUpperCase(str) {
  const reg = /^[A-Z]+$/
  return reg.test(str)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validAlphabets(str) {
  const reg = /^[A-Za-z]+$/
  return reg.test(str)
}

/**
 * @param {string} email
 * @returns {Boolean}
 */
export function validEmail(email) {
  const reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return reg.test(email)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function isString(str) {
  if (typeof str === 'string' || str instanceof String) {
    return true
  }
  return false
}

/**
 * @param {Array} arg
 * @returns {Boolean}
 */
export function isArray(arg) {
  if (typeof Array.isArray === 'undefined') {
    return Object.prototype.toString.call(arg) === '[object Array]'
  }
  return Array.isArray(arg)
}

export function isValidPasswordLength(password) {
  const reg = /^.{8,20}$/
  return reg.test(password)
}

export function isValidPasswordComplexity(password) {
  const reg = /^(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9])/
  return reg.test(password)
}

export function isValidMacAddress(string) {
  const reg = /^([0-9a-fA-F]{2})(([/\s:-][0-9a-fA-F]{2}){5})$/
  return reg.test(string)
}

export function isValidNumOrLetter(string) {
  const reg = /^[A-Za-z0-9]+$/
  return reg.test(string)
}

//  数字、字母、或符号（./-_:）
export function isValidNumOrLetterOrSymbol(string) {
  const reg = /^[A-Za-z0-9\-\/_:.]+$/
  return reg.test(string)
}

export function isIncludeChinese(string) {
  const reg = /[\u4E00-\u9FA5]/
  return reg.test(string)
}

export function isValidMobilePhoneNumber(string) {
  const reg = /^1[3-9]\d{9}$/
  return reg.test(string)
}

export function isValidPhoneNumber(string) {
  const mobileReg = /^1[3456789]\d{9}$/
  const landlineReg = /^0\d{2,3}-?\d{7,8}$/
  return mobileReg.test(string) || landlineReg.test(string)
}

export const validatePhoneNumber = (rule, value, callback) => {
  if (value && !(isValidPhoneNumber(value))) {
    callback(new Error('格式错误'))
  } else {
    callback()
  }
}

//  数字
export function isValidNumber(string) {
  const reg = /^-?\d+(\.\d+)?$/
  return reg.test(string)
}

export const validateNumOrLetterOrSymbol = (rule, value, callback) => {
  if (value && !(isValidNumOrLetterOrSymbol(value))) {
    callback(new Error('请输入数字，字母或特殊符号'))
  } else {
    callback()
  }
}
